import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { AGENT_TRAINING } from "@/constants/testIds";

const SELECT_CLASS = "w-full h-10 rounded-md border border-input bg-background px-3 text-sm";

// Fix AO (2026-10-23): crear o editar un ejemplo de entrenamiento (lo que escribe el lead y como responde el agente).
export default function TrainingExampleDialog({ open, onOpenChange, item, onSubmit }) {
  const editing = Boolean(item);
  const [rating, setRating] = useState("up");
  const [lead, setLead] = useState("");
  const [reply, setReply] = useState("");
  const [comment, setComment] = useState("");
  const [correction, setCorrection] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setRating(item?.rating || "up");
    setLead(item?.lead_message || "");
    setReply(item?.reply || "");
    setComment(item?.comment || "");
    setCorrection(item?.correction || "");
    setSaving(false);
  }, [open, item]);

  const down = rating === "down";
  const canSave = !saving && lead.trim() && reply.trim() && (!down || comment.trim() || correction.trim());
  const submit = async () => {
    setSaving(true);
    const values = { lead_message: lead.trim(), reply: reply.trim(), comment: comment.trim() || null, correction: down ? correction.trim() || null : null };
    const ok = await onSubmit(editing ? values : { rating, ...values });
    if (!ok) setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid={AGENT_TRAINING.dialog}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{editing ? "Editar ejemplo" : "Nuevo ejemplo"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {!editing && (
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Tipo de ejemplo</Label>
              <select className={SELECT_CLASS} value={rating} onChange={(e) => setRating(e.target.value)} data-testid={AGENT_TRAINING.ratingSelect}>
                <option value="up">Buena respuesta (el agente debe responder así)</option>
                <option value="down">Respuesta a evitar (con el motivo o la respuesta correcta)</option>
              </select>
            </div>
          )}
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Lo que escribe el lead</Label>
            <Textarea value={lead} maxLength={700} rows={2} onChange={(e) => setLead(e.target.value)} placeholder="Hola, quiero info del relleno de labios" data-testid={AGENT_TRAINING.leadInput} />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">{down ? "Respuesta que NO sirve" : "Cómo debe responder el agente"}</Label>
            <Textarea value={reply} maxLength={700} rows={3} onChange={(e) => setReply(e.target.value)} data-testid={AGENT_TRAINING.replyInput} />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">{down ? "Motivo" : "Por qué sirve (opcional)"}</Label>
            <Textarea value={comment} maxLength={500} rows={2} onChange={(e) => setComment(e.target.value)} data-testid={AGENT_TRAINING.commentInput} />
          </div>
          {down && (
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Mejor respuesta (si no escribís el motivo, es obligatoria)</Label>
              <Textarea value={correction} maxLength={700} rows={3} onChange={(e) => setCorrection(e.target.value)} data-testid={AGENT_TRAINING.correctionInput} />
            </div>
          )}
          <p className="text-xs text-muted-foreground">Los precios y la información de los tratamientos salen siempre de la base de conocimiento: el ejemplo enseña el estilo y el modo de responder.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={submit} disabled={!canSave} className="bg-brand hover:bg-brand-hover text-white" data-testid={AGENT_TRAINING.saveButton}>{saving ? "Guardando..." : "Guardar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
